mutation DeleteEmoteWall($emoteWallId: ID!) {
  result: StreamToolsDeleteEmoteWall(emoteWallId: $emoteWallId) {
    id
    deleted
  }
}
